import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  style: {
    "height": "100%",
    "width": "100%",
    "font-size": "26px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", null, "WebSocket 接收消息", -1)), _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messages, (msg, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, _toDisplayString(msg.timestamp) + " - " + _toDisplayString(msg.message), 1);
  }), 128))])]);
}